function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "hsbc"
}, React.createElement("polyline", {
  id: "Fill-1",
  fill: "currentcolor",
  fillRule: "nonzero",
  points: "24.374 0.755 24.374 49.245 1.42108547e-14 25 24.374 0.755"
}), React.createElement("polyline", {
  id: "Fill-2",
  fill: "currentcolor",
  fillRule: "nonzero",
  points: "24.372 0.755 72.75 0.755 48.469 25.113 24.28 0.847 24.372 0.755"
}), React.createElement("polyline", {
  id: "Fill-3",
  fill: "currentcolor",
  fillRule: "nonzero",
  points: "72.677 49.245 72.677 0.755 97.051 25 72.677 49.245"
}), React.createElement("polyline", {
  id: "Fill-4",
  fill: "currentcolor",
  fillRule: "nonzero",
  points: "72.679 49.245 24.3 49.245 48.582 24.887 72.771 49.153 72.679 49.245"
})));

var SvgHsbcMiniMono = function SvgHsbcMiniMono(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 97 50",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHsbcMiniMono, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hsbc-mini-mono.b8838e59.svg";
export { ForwardRef as ReactComponent };